"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconHomeApplianceThematic = void 0;
var React = __importStar(require("react"));
var IconHomeApplianceThematic = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M21,16.5996 L21,6.4006 C21,6.1836 20.817,5.9996 20.6,5.9996 L16,5.9996 L16,16.9996 L20.6,16.9996 C20.817,16.9996 21,16.8166 21,16.5996 Z M3.4,16.9996 L15,16.9996 L15,5.9996 L3.4,5.9996 C3.183,5.9996 3,6.1836 3,6.4006 L3,16.5996 C3,16.8166 3.183,16.9996 3.4,16.9996 Z M20.6,4.9996 C21.372,4.9996 22,5.6276 22,6.4006 L22,16.5996 C22,17.3716 21.372,17.9996 20.6,17.9996 L19,17.9996 L19,18.4996 C19,18.7766 18.776,18.9996 18.5,18.9996 C18.224,18.9996 18,18.7766 18,18.4996 L18,17.9996 L16,17.9996 L15,17.9996 L6,17.9996 L6,18.4996 C6,18.7766 5.776,18.9996 5.5,18.9996 C5.224,18.9996 5,18.7766 5,18.4996 L5,17.9996 L3.4,17.9996 C2.628,17.9996 2,17.3716 2,16.5996 L2,6.4006 C2,5.6276 2.628,4.9996 3.4,4.9996 L15,4.9996 L16,4.9996 L20.6,4.9996 Z M5,15 L13,15 L13,8 L5,8 L5,15 Z M4,16 L4,7 L14,7 L14,16 L4,16 Z M19.5,8 C19.776,8 20,8.224 20,8.5 C20,8.776 19.776,9 19.5,9 L17.5,9 C17.224,9 17,8.776 17,8.5 C17,8.224 17.224,8 17.5,8 L19.5,8 Z M18.5,11 C18.776,11 19,11.224 19,11.5 C19,11.776 18.776,12 18.5,12 C18.224,12 18,11.776 18,11.5 C18,11.224 18.224,11 18.5,11 Z M18.5,13 C18.776,13 19,13.224 19,13.5 C19,13.776 18.776,14 18.5,14 C18.224,14 18,13.776 18,13.5 C18,13.224 18.224,13 18.5,13 Z M18.5,15 C18.776,15 19,15.224 19,15.5 C19,15.776 18.776,16 18.5,16 C18.224,16 18,15.776 18,15.5 C18,15.224 18.224,15 18.5,15 Z" }))); };
exports.IconHomeApplianceThematic = IconHomeApplianceThematic;
exports.IconHomeApplianceThematic.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconHomeApplianceThematic;
